export enum SessionCode {
    InventoryPlanningFilterData = "InventoryPlanningFilterData",
    InventoryPlanningMasterData = "InventoryPlanningMasterData",
    PartNosMasterData = "PartNosMasterData",
    PartCatColumnsList = "PartCatColumnsList",
    PartPlanningColumnsList = "PartPlanningColumnsList",
    userEmail = "userEmail"

}